import { TextField, TextFieldProps } from "@mui/material";
import { IGWidget, addClass } from "../GWidget";
import { IFormFieldProps, useValidator } from "../form/Validators";

export interface IGTextFieldProps extends IGWidget, IFormFieldProps<string>, Omit<TextFieldProps,"value"|"defaultValue"> {
    value?:string;
    defaultValue?:string;
    floatLabel?:string
    formatter?:(val:string) => string
    onEnter?:(val:string) => void
}

export default function GTextField(props:IGTextFieldProps) {
    const {onChange,helperText,floatLabel,form,controlName,onEnter,formatter,onBlur,...textProps} = props
    const {control, error} = useValidator<string>({...props})
    
    const _onChange = (e:any) => {
        const formatted = formatter ? formatter(e.target.value) : e.target.value
        if (formatted!=e.target.value) e.target.value = formatted
        control?.update(e.target.value) 
        form?.setDirty(true)
        props.onChange?.(e)
    }

    const onKeyDown = (e:any) => {
        if (e.key=="Enter") onEnter?.(e.target.value||"")
    }

    const _onBlur = (e:any) => {
        control?.setDirty(true, true)
        form?.setDirty(true)
        onBlur?.(e)
    }

    return <TextField className={addClass("", props)} onChange={_onChange} onKeyDown={onKeyDown}
        label={floatLabel} helperText={props.helperText||error} error={!!error} onBlur={_onBlur}
        size="small" variant="outlined" {...textProps}/>
}
